/* eslint-disable */
/* global document, window */
(function () {
  function initMegaMenuHorizon(event) {
    // Permanently protect the CSS from sticky header cloning by moving it to the <head>
    const styleBlock = document.querySelector('style[data-mega-menu-style]');
    if (styleBlock && styleBlock.parentElement !== document.head) {
      document.head.appendChild(styleBlock);
    }

    document.querySelectorAll('[data-mega-menu-root]').forEach(root => {
      // Check if we are loading a specific section via Theme Editor
      if (event && event.type === 'shopify:section:load') {
        const sectionId = root.id.replace('mega-menu-', '');
        if (sectionId !== event.detail.sectionId) {
          return;
        }
      }

      if (root.dataset.initialized === 'true' && (!event || event.type !== 'shopify:section:load')) {
        return;
      }
      root.dataset.initialized = 'true';

      // Handle nested sub-menu accordions globally so they work when moved to body
      if (!root.dataset.accordionListenerAttached) {
        document.addEventListener('click', (e) => {
          const summary = e.target.closest('.mega-menu__summary');
          if (!summary) return;

          const closestRoot = summary.closest('.mega-menu-wrapper');
          const closestMenu = summary.closest('.mega-menu-new');

          // Verify this summary belongs to this mega menu instance
          if (closestRoot !== root && closestMenu !== megaMenuNew) return;

          const currentDetails = summary.closest('details');
          if (!currentDetails) return;

          const isOpening = !currentDetails.hasAttribute('open');

          if (isOpening) {
            const parentDetails = currentDetails.parentElement.closest('details');

            const container = closestMenu || root;
            container.querySelectorAll('.mega-menu__details[open]').forEach(openDetails => {
              if (openDetails === currentDetails) return;
              if (openDetails.contains(currentDetails)) return;

              const openParentDetails = openDetails.parentElement.closest('details');
              if (openParentDetails === parentDetails) {
                openDetails.removeAttribute('open');
              }
            });
          }
        });
        root.dataset.accordionListenerAttached = 'true';
      }

      const trigger = root.querySelector('[data-mega-menu-trigger]');
      const columnToggles = Array.from(root.querySelectorAll('.mega-menu-column__toggle'));
      let megaMenuNew = root.querySelector('.mega-menu-new');
      let megaMenuOverlay = root.querySelector('.mega-menu-overlay');

      const isTabletOrMobile = () => window.matchMedia('(max-width: 1024px)').matches;

      // Clean up any orphaned elements in body from Theme Editor reloads or sticky clones
      document.querySelectorAll('body > .mega-menu-overlay, body > .mega-menu-new').forEach(el => {
        if (el !== megaMenuOverlay && el !== megaMenuNew) el.remove();
      });

      const moveMenuToBody = () => {
        if (!megaMenuNew || !megaMenuOverlay) return;
        if (isTabletOrMobile()) {
          document.body.appendChild(megaMenuOverlay);
          document.body.appendChild(megaMenuNew);
        } else {
          root.insertBefore(megaMenuOverlay, megaMenuNew);
          root.appendChild(megaMenuNew);
        }
      };

      // Move immediately on load
      moveMenuToBody();

      // Handle window resize dynamically to snap menu elements back to proper place
      let currentWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth !== currentWidth) {
          const crossedBreakpoint = (currentWidth > 1024 && window.innerWidth <= 1024) || (currentWidth <= 1024 && window.innerWidth > 1024);
          currentWidth = window.innerWidth;
          if (crossedBreakpoint) {
            moveMenuToBody();
            closeMenu();
          }
        }
      });

      const openFirstColumn = () => {
        if (!isTabletOrMobile() || !megaMenuNew) return;
        const columns = megaMenuNew.querySelectorAll('.mega-menu-column');
        if (!columns.length) return;
        const firstColumn = columns[0];
        if (!firstColumn.classList.contains('active')) {
          firstColumn.classList.add('active');
          const firstToggle = firstColumn.querySelector('.mega-menu-column__toggle');
          if (firstToggle) firstToggle.setAttribute('aria-expanded', 'true');
        }
      };

      const openMenu = () => {
        if (!document.body.classList.contains('mega-menu-active')) {
          moveMenuToBody();
          document.body.classList.add('mega-menu-active');
          root.classList.add('active');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          if (isTabletOrMobile()) {
            document.body.style.overflow = 'hidden';
            openFirstColumn();
          }
        }
      };

      const closeMenu = () => {
        if (document.body.classList.contains('mega-menu-active')) {
          document.body.classList.remove('mega-menu-active');
          root.classList.remove('active');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');

          // Revert all Dawn hamburger icons back to the hamburger state
          document.querySelectorAll('header-drawer summary, .header__icon--menu, .header__icon[aria-controls="menu-drawer"]').forEach(hamburger => {
            hamburger.setAttribute('aria-expanded', 'false');
            const details = hamburger.closest('details');
            if (details) details.removeAttribute('open');
          });

          const columnToggles = Array.from(document.querySelectorAll('.mega-menu-column__toggle'));
          columnToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
          if (megaMenuNew) {
            megaMenuNew.querySelectorAll('.mega-menu-column.active').forEach((column) => {
              column.classList.remove('active');
            });
          }
          document.body.style.overflow = '';
        }
      };

      if (trigger) {
        // Use event delegation for the trigger so it works flawlessly inside cloned sticky headers
        if (!root.dataset.triggerListenerAttached) {
          document.addEventListener('click', (event) => {
            const clickedTrigger = event.target.closest('[data-mega-menu-trigger]');
            if (clickedTrigger && document.body.contains(clickedTrigger)) {
              // Ensure the clicked trigger belongs to this specific menu (if multiple exist)
              const closestRoot = clickedTrigger.closest('.mega-menu-wrapper');
              if (closestRoot && closestRoot.id === root.id) {
                if (!isTabletOrMobile()) return;
                event.preventDefault();
                if (document.body.classList.contains('mega-menu-active')) {
                  closeMenu();
                } else {
                  openMenu();
                }
              }
            }
          });
          root.dataset.triggerListenerAttached = 'true';
        }
      }

      // Attach close logic to overlay and X buttons
      const attachCloseListeners = () => {
        const closeButtons = [megaMenuOverlay, ...(megaMenuNew ? megaMenuNew.querySelectorAll('[data-mega-close]') : [])];
        closeButtons.forEach(btn => {
          if (!btn) return;
          // Use cloning to strip old event listeners
          const newBtn = btn.cloneNode(true);
          if (btn.parentNode) {
            btn.parentNode.replaceChild(newBtn, btn);
          }
          newBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            closeMenu();
          });

          // Re-assign references if we replaced the DOM elements
          if (btn === megaMenuOverlay) megaMenuOverlay = newBtn;
          if (megaMenuNew && btn !== megaMenuOverlay) {
            // If we replaced a close button inside megaMenuNew, we don't strictly need to update a specific variable
            // because it's just a child node, but we replaced it in the DOM, so it's fine.
          }
        });
      };
      attachCloseListeners();

      // INTERCEPT DAWN HAMBURGER VIA DELEGATION
      if (!root.dataset.hamburgerListenerAttached) {
        document.addEventListener('click', (e) => {
          const hamburger = e.target.closest('header-drawer summary, .header__icon--menu, .header__icon[aria-controls="menu-drawer"]');
          if (hamburger) {
            if (!isTabletOrMobile()) return;

            // Ensure we stop Dawn's native details toggle and JS entirely
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (document.body.classList.contains('mega-menu-active')) {
              closeMenu();
            } else {
              openMenu();
              // Sync the hamburger icon to show X
              hamburger.setAttribute('aria-expanded', 'true');
              const details = hamburger.closest('details');
              if (details) {
                details.setAttribute('open', '');
                details.classList.add('menu-open');
              }
            }
          }
        }, true);
        root.dataset.hamburgerListenerAttached = 'true';
      }

      // Handle column toggles globally via delegation so they work on mobile when detached
      if (!root.dataset.columnListenerAttached) {
        document.addEventListener('click', (e) => {
          const toggle = e.target.closest('.mega-menu-column__toggle');
          if (!toggle) return;

          const closestMenu = toggle.closest('.mega-menu-new');
          if (closestMenu !== megaMenuNew) return;

          if (!isTabletOrMobile()) return;
          const column = toggle.closest('.mega-menu-column');
          if (!column) return;

          const isOpen = column.classList.toggle('active');
          toggle.setAttribute('aria-expanded', String(isOpen));

          if (megaMenuNew) {
            megaMenuNew.querySelectorAll('.mega-menu-column').forEach((otherColumn) => {
              if (otherColumn !== column) {
                otherColumn.classList.remove('active');
                const otherToggle = otherColumn.querySelector('.mega-menu-column__toggle');
                if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
              }
            });
          }
        });
        root.dataset.columnListenerAttached = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHorizon);
  } else {
    initMegaMenuHorizon();
  }

  document.addEventListener('shopify:section:load', initMegaMenuHorizon);
})();
